jQuery(document).on('ready', function(){
	BASE.onReady();
	YOUTUBE.onReady();
});



var BASE = {
	onReady: function(){
		BASE.initTpl();
		BASE.initSlick();
		BASE.initNav();
		BASE.initLangNav();
		BASE.initMobileNav();
		BASE.initContactform();

		jQuery(document).on('click', 'button.trigger-slick-prev', BASE.slickPrev);
		jQuery(document).on('click', 'button.trigger-slick-next', BASE.slickNext);
		
		jQuery(document).on('click', '.block-accordeon .item header', BASE.openAccordeon);

		jQuery(document).on( 'click', '.trigger-mobile-nav', BASE.triggerMobileNav);
	},


	initTpl: function(){
		if(jQuery('.slider.hero').length < 1 )
			return;

		jQuery('.slider.hero').closest('article').addClass('has-slider');
	},



	initSlick: function(){
		jQuery('.slider.hero').slick({
		 	dots: false,
		 	infinite: true,
		 	speed: 100,
		 	slidesToShow: 1,
		 	slidesToScroll: 1,
			autoplay: false,
			autoplaySpeed: 4500,	
			infinite: true,
			speed: 1000,
			fade: true,
			cssEase: 'linear',
			rows: 0,
  			adaptiveHeight: true,
		});

		jQuery('.slider.gallery').slick({
		 	dots: false,
		 	arrows:false,
		 	infinite: true,
		 	speed: 100,
		 	slidesToShow: 1,
		 	slidesToScroll: 1,
			autoplay: false,
			autoplaySpeed: 4500,	
			infinite: true,
			speed: 1000,
			fade: true,
			cssEase: 'linear',
			rows: 0,
		  	responsive: [
		    	{
		      		breakpoint: 856,
			      	settings: {
			      		centerMode: true,
			        	slidesToShow: 1,
			        	slidesToScroll: 1,
			        	infinite: true,
			        	dots: false
			      	}
		    	}
		  	]
		});

		jQuery('.slider.testimonial').slick({
		 	dots: true,
		 	arrows:false,
		 	infinite: true,
		 	speed: 100,
		 	slidesToShow: 1,
		 	slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 4500,	
			infinite: true,
			speed: 1000,
			fade: true,
			cssEase: 'linear',
			rows: 0,
		});
	},



	slickPrev: function(){
		jQuery('.slider.gallery').slick('slickPrev');
	},



	slickNext: function(){
		jQuery('.slider.gallery').slick('slickNext');
	},



	initNav: function(){
		jQuery('.sub-menu').hover(
		       function(){ jQuery(this).parent().addClass('hover') },
		       function(){ jQuery(this).parent().removeClass('hover') }
		)
	},



	initLangNav: function(){
		if(jQuery('html').attr('lang') == 'en-US')
			jQuery('body').addClass('is-en').removeClass('is-de');
		
		if(jQuery('html').attr('lang') == 'de-DE')
			jQuery('body').addClass('is-de').removeClass('is-en');

	},



	triggerMobileNav: function(){
		if(jQuery('i', this).hasClass('fa-bars')){
			jQuery('#mobile-nav').addClass('show');
			
		} else {
			jQuery('#mobile-nav').removeClass('show');
		}

		return false;
	},



	initMobileNav: function(){
		if(jQuery('#mobile-nav').length < 1){
			jQuery('body').append(jQuery('#main-navigation-container').clone().attr('id', 'mobile-nav'));

			jQuery('#mobile-nav').prepend('<a href="#" class="trigger-mobile-nav"><i class="fas fa-times fa-2x "></i></a>')
		}
	},


 	initContactform: function(){
 		if(jQuery('.wp-block-sn-wide-content .block-contact-form').length < 1)
 			return;

 		jQuery('.wp-block-sn-wide-content .block-contact-form').parent().addClass('has-contactform');
 		jQuery('.wp-block-sn-wide-content .block-contact-form').closest('.wp-block-columns').addClass('has-contactform');
 	},



 	openAccordeon: function(){
 		BASE.context = jQuery(this).parent().parent();

 		if( jQuery(this).parent().hasClass('open') ) {
 			jQuery('.item', BASE.context).removeClass('open');
 			jQuery('.item .content', BASE.context).slideUp();

 		} else {
 			jQuery('.item', BASE.context).removeClass('open');
 			jQuery('.item .content', BASE.context).slideUp();

 			jQuery(this).next().slideDown().addClass('open');
 			jQuery(this).parent().addClass('open');

 		}
 		
 	}
}





var YOUTUBE = {
	onReady: function(){
		jQuery(document).on('click', '.btn-play', YOUTUBE.initYoutube);
	},



	initYoutube: function(){
		YOUTUBE.context = jQuery(this).closest('.block-youtube');
		YOUTUBE.id = YOUTUBE.context.data('ytid');
		YOUTUBE.container = YOUTUBE.context.data('container');

		if(jQuery('body').hasClass('youtube-ready')){
			YOUTUBE.initPlayer();
		} else {
			jQuery.getScript( "//www.youtube.com/player_api"); //API laden
		}
	},



	initPlayer : function(){
		
		console.log(YOUTUBE.context.attr('id'));
		
		
		
		jQuery('.video-container', YOUTUBE.context).addClass('play');

  		var eventsVar = {
			'onReady': onPlayerReady, //Call Autoplay
			'onStateChange': onPlayerStateChange //Redirect after Video Ends
		};


		player = new YT.Player(YOUTUBE.container, {//DIV #player wird angesprochen
					width: YOUTUBE.context.outerWidth(), /* Breite des Players über CSS auf 100% */
					height: YOUTUBE.context.outerHeight(), /* Höhe des Players wird per JS errechnet */
					videoId: YOUTUBE.id, //Video ID von Youtube eintragen (wp_localize_script())
					events: {
						'onReady': onPlayerReady, //Call Autoplay
						'onStateChange': onPlayerStateChange //Redirect after Video Ends
					}
		});
	}

}




function onYouTubePlayerAPIReady() { 
	jQuery('body').addClass('youtube-ready');
	

	YOUTUBE.initPlayer();
}



function onPlayerReady(event) {
	event.target.playVideo();
}


function onPlayerStateChange(event) {        

}

